








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/family/edit/EditAdresse.vue'
import { getDefaultAloFamily, AloFamily } from '@/models/alo/AloFamily'
import { toStringDictionary } from '@/utils/groupBy'

@Component({
  name: 'ReadAdresse',    
   props: {
    family:{      
      default:getDefaultAloFamily()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadAdresse extends Vue {
  private family!:AloFamily
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.family) }
}
